var React = require('react');

function Roundfacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M16.7977 26.0984H19.6537V18.7072H22.0418L22.4024 15.8317H19.6537V13.9889C19.6537 13.1587 19.8779 12.5917 21.0281 12.5917H22.4999V10.0098C22.2465 9.97944 21.379 9.89844 20.3652 9.89844C18.2403 9.89844 16.7977 11.2451 16.7977 13.7054V15.8317H14.3999V18.7072H16.7977V26.0984Z","fill":"#EEEEEE","key":1})]);
}

Roundfacebook.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Roundfacebook;

Roundfacebook.default = Roundfacebook;
